import DealsPreviewBanner from './DealsPreviewBanner';

export default DealsPreviewBanner;
